import { FactoryDigitalmallBackofficeV1Store } from "../../app/genericApiGenerated";

const buildStore = (
  data: any,
  selectedStore?: FactoryDigitalmallBackofficeV1Store
): FactoryDigitalmallBackofficeV1Store => {
  const store: FactoryDigitalmallBackofficeV1Store = { display_name: "" };

  // This one for handling concurrent updates
  if (
    selectedStore !== undefined &&
    selectedStore["meta"] !== undefined &&
    selectedStore["meta"]["update_time"] !== undefined
  ) {
    store.meta = {
      ...store.meta,
      update_time: selectedStore["meta"]["update_time"],
    };
  }

  if (data["name"] !== undefined) {
    store.name = data["name"];
  }

  if (data["display_name"] !== undefined) {
    store.display_name = data["display_name"];
  }

  if (data["category"] !== undefined) {
    store.category = data["category"];
  }

  if (data["sub_category"] !== undefined) {
    store.sub_category = data["sub_category"];
  }

  if (data["description"] !== undefined) {
    store.description = data["description"];
  }

  if (data["logo"] !== undefined) {
    store.logo = data["logo"];
  }

  if (data["website_uri"] !== undefined) {
    store.website_uri = data["website_uri"];
  }

  if (data["phone_number"] !== undefined) {
    store.phone_number = data["phone_number"];
  }

  if (data["location_address"] !== undefined) {
    store.location_address = data["location_address"];
  }

  if (data["opening_hours"] !== undefined) {
    store.opening_hours = data["opening_hours"];
  }

  if (data["retailer"] !== undefined) {
    store.retailer = data["retailer"];
  }

  if (data["mall"] !== undefined) {
    store.mall = data["mall"];
  }

  if (data["meta"] !== undefined && data["meta"]["create_time"] !== undefined) {
    store.meta = {
      ...store.meta,
      create_time: data["meta"]["create_time"],
    };
  }

  if (
    data["meta"] !== undefined &&
    data["meta"]["creation_user"] !== undefined
  ) {
    store.meta = {
      ...store.meta,
      creation_user: data["meta"]["creation_user"],
    };
  }

  if (data["meta"] !== undefined && data["meta"]["update_time"] !== undefined) {
    store.meta = {
      ...store.meta,
      update_time: data["meta"]["update_time"],
    };
  }

  if (data["meta"] !== undefined && data["meta"]["update_user"] !== undefined) {
    store.meta = {
      ...store.meta,
      update_user: data["meta"]["update_user"],
    };
  }

  if (data["meta"] !== undefined && data["meta"]["delete_time"] !== undefined) {
    store.meta = {
      ...store.meta,
      delete_time: data["meta"]["delete_time"],
    };
  }

  if (
    data["meta"] !== undefined &&
    data["meta"]["deletion_user"] !== undefined
  ) {
    store.meta = {
      ...store.meta,
      deletion_user: data["meta"]["deletion_user"],
    };
  }

  if (data["meta"] !== undefined && data["meta"]["sfmc_mid"] !== undefined) {
    store.meta = {
      ...store.meta,
      sfmc_mid: data["meta"]["sfmc_mid"],
    };
  }

  if (
    data["meta"] !== undefined &&
    data["meta"]["resource_name"] !== undefined
  ) {
    store.meta = {
      ...store.meta,
      resource_name: data["meta"]["resource_name"],
    };
  }

  if (
    data["meta"] !== undefined &&
    data["meta"]["operation_name"] !== undefined
  ) {
    store.meta = {
      ...store.meta,
      operation_name: data["meta"]["operation_name"],
    };
  }

  return store;
};
export default buildStore;
